<template>
  <div class="container order-list">
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>

    <div class="content" style="margin-top: 10px;">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>


      <orders-list-table :dataList="page.list" :heightStr="columns.height" :config="columnCommon.config"
        typeStr="logisticsOrder" @tableSelectionChange="handleSelectionChange"></orders-list-table>
      <!-- 分页start -->
      <!-- <div class="page">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="searchForm.pageNo" :page-sizes="[3, 5, 10, 20, 50]" :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="page.totalNum">
        </el-pagination>
      </div> -->
      <!-- 分页end -->
    </div>
  </div>
</template>
  
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import ordersListTable from '../components/ordersListTableL2'
export default {
  components: {
    ordersListTable,
    breadcrumbTop,
    breadcrumbSearch
  },
  data() {
    return {
      radio1: ' ',
      searchList: {
        list: [
          { title: '订单拆单', path: '', type: '0' },
          { title: '列表数据', path: '', type: '1' }
        ]
      },
      dataList: {
        list: [
          { title: '订单管理', path: '', type: '0' },
          { title: '拆单订单', path: '', type: '1' }
        ]
      },
      exportLoading: false,
      loadingState: false,
      loadingStateTwo: false,
      loadingStateThree: false,
      loadingStateFour: false,
      loading: false,
      parArray: [],
      userType: '',
      columns: {
        type: 'all',
        height: '5000px',
        sortObj: {},
        config: []
      },
      // 公共  column
      columnCommon: {
        type: 'common',
        sortObj: { prop: 'marketPrice', order: 'descending' }, // 排序
        config: [
          { prop: 'orderNo', label: '订单编号', width: 100, slot: 'orderNo' },
          { prop: 'payTypeLabel', label: '商品信息', width: 200, slot: 'goods' },
          { prop: 'quantity', label: '商品数量', width: 60 },
          { prop: 'userRemark', label: '备注', width: 150 },
          { prop: 'statusLabel', label: '订单状态', slot: 'order' },
          // { prop: 'userCommission', label: '用户佣金', width: 150, slot: 'userCommission', align: 'center' },
          // {
          //   prop: 'vipCommission', label: '服务商佣金', width: 150, slot: 'vipCommission', align: 'center'
          // },
          {
            prop: ' ', label: '操作', width: 100, align: 'right'
          }
        ]
      },
      multipleSelection: '', // 多选
      cancelOrderId: '', // 取消订单id
      setCloseOrder: '', // 取消订单参数
      statusCount: { // 物流订单分页数量统计
        totalCount: 100, // 全部数量
        waitingPayCount: 12,
        waitingStockingCount: 12,
        stockedCount: 12,
        deliveredCount: 13,
        waitingDeliveryCount: 14,
        receivedCount: 10,
        closedCount: 10,
        errorCount: 0
      },
      searchForm: {
        ids: [],
        goodsName: null,
        userInfo: null,
        postUserInfo: null,
        orderNo: null,
        logisticsNumber: null,
        activityTypeIdList: [],
        orderStatus: null,
        createTimeStart: null,
        createTimeEnd: null,
        payTimeStart: null,
        payTimeEnd: null,
        pageNo: 1,
        pageSize: 10,
        goodsType: ''
      },
      currentTab: '', // 当前列表状态
      // 分配状态
      currentTabStatus: {
        all: '', // 全部
        beforePay: 1, // 待支付
        choicing: 2, // 备货中
        signFor: 3, // 待签收
        accomplish: 4, // 已完成
        afterSale: 6 // 已关闭
      },
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '2',
          dictName: '礼包商品'
        },

      ],
      columnTitle: this.column,
      breadcrumbConfig: {
        list: [
          {
            title: '订单管理',
            type: '#ff0000',
            path: ''
          },
          {
            title: '运营订单',
            type: '1',
            path: ''
          }

        ]
      },
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      rQuery: {},
      afterSale: '',
      dictionaries: {},
      createTime: [],
      payTime: [],
      jhyx_order_types: [

      ],
      activityTypeIdList: []
    }
  },
  watch: {
    $route: {
      handler(val, oldVal) {

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {
    this.getDictionaries('jhyx_order_type')
    this.getDictionaries('platform_order_status')
    this.getType()
    this.fetchData()// 初始化，搜索需要的列表数据
    this.getCount()
  },
  mounted() {
    // this.$nextTick(_ => {
    //   const rQuery = this.rQuery
    //   if (rQuery.state) {
    //     this.onChangeCurrentTab(Number(rQuery.state))
    //     this.currentTab = rQuery.state || ''
    //   } else {
    //     this.onChangeCurrentTab() // fetchData 在这里执行
    //   }
    //   console.log('this.currentTab = ', this.currentTab)
    // })
  },
  methods: {
    selectTag(val) {
      console.log(val)
      if (val == null) {
        this.searchForm.orderType = ''

        this.searchForm.activityTypeIdList = []
        return
      }
      let dd = this.$refs.cascaderf.getCheckedNodes()
      // console.log('多点',dd.value,dd.label)
      if (dd[0].value == 'o1' && dd[0].label == '普通订单') {
        this.searchForm.orderType = 1
        //  this.activityTypeIdList = []
        this.searchForm.activityTypeIdList = []
      } else if (dd[0].value == 'o3' && dd[0].label == '身份订单') {
        this.searchForm.orderType = 3
        //  this.activityTypeIdList = []
        this.searchForm.activityTypeIdList = []
      } else {
        this.searchForm.activityTypeIdList = []
        this.searchForm.orderType = 2
        this.searchForm.activityTypeIdList.push(val)
      }
      // if (val.length==1&&val.indexOf('o1') != -1) {
      //   this.searchForm.orderType = 1
      //   this.activityTypeIdList = ['o1']
      //   this.searchForm.activityTypeIdList = []
      // } else if (val.length==1&&val.indexOf('o3') != -1){
      //   this.searchForm.orderType = 3
      //   this.activityTypeIdList = ['o3']
      //   this.searchForm.activityTypeIdList = []
      // }else if (val.length==2&&(val.indexOf('o1') != -1||val.indexOf('o3') != -1)){
      //   if(val.indexOf('o1') != -1){
      //     this.activityTypeIdList = ['o1']
      //     this.searchForm.orderType = 1
      //   }else{
      //     this.activityTypeIdList=['o3']
      //     this.searchForm.orderType = 3
      //   }
      //   this.searchForm.activityTypeIdList = []
      // }else {
      //   this.searchForm.orderType = 2
      //   this.searchForm.activityTypeIdList = val
      // }
      console.log(val)
      //   if(val.indexOf('o1') != -1){
      //     this.activityTypeIdList = ['o1']
      //     this.searchForm.orderType = 1
      //   }else{
      //     this.activityTypeIdList=['o3']
      //     this.searchForm.orderType = 3
      //   }
      this.$forceUpdate()
    },
    expandChange() {
      this.searchForm.activityTypeIdList = []
      this.activityTypeIdList = []
    },
    getType() {
      // this.axios.get('/marketActivateType/list').then(res => {
      //   if (res.code == 0) {

      //   }
      // })
    },
    getCount() {
      this.searchForm.orderStatus = null
      this.axios.post('/orders/getStatusCount', this.searchForm).then(res => {
        if (res.code == 0) {
          this.statusCount = res.data
        }
      })
    },
    selectData() {
      this.searchForm.orderStatus = this.radio1
      this.fetchData()
    },
    //批量导出
    lotsExport() {
      let ids = []
      if (this.multipleSelection) {
        this.multipleSelection.forEach(item => {
          ids.push(item.id)
        })
      }
      this.exportLoading = true
      this.searchForm.ids = ids
      this.searchForm.orderStatus = this.radio1
      if (this.createTime) {
        this.searchForm.createTimeStart = this.createTime[0]
        this.searchForm.createTimeEnd = this.createTime[1]
      }
      if (this.payTime) {
        this.searchForm.payTimeStart = this.payTime[0]
        this.searchForm.payTimeEnd = this.payTime[1]
      }
      this.axios.post('/orders/export', this.searchForm).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
      // if (ids.length == 0 && this.searchForm == {}) {
      //   this.$message.warning('请选择导出数据')
      //   return
      // } else {
      //   this.exportLoading = true
      //   this.searchForm.ids = ids
      //   this.axios.post('/orders/export', this.searchForm).then(res => {
      //     if (res.code == 0) {
      //       this.exportLoading = false
      //       this.$message.success('导出成功')
      //       this.downloadlink(res.data)
      //     }
      //   })
      // }
    },
    //导出本月数据
    monthExport() {
      this.exportLoading = true
      this.axios.post('/orders/monthlyExport', {}).then(res => {
        if (res.code == 0) {
          this.exportLoading = false
          this.$message.success('导出成功')
          this.downloadlink(res.data)
        }
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/getDictGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
            if (type == 'jhyx_order_type') {
              this.axios.get('/marketActivateType/list').then(res1 => {
                if (res1.code == 0) {
                  let tempArr = []
                  this.dictionaries.jhyx_order_type.forEach(item => {
                    if (item.dictName == '普通订单' || item.dictName == '身份订单') {
                      // item.children = []
                    } else {
                      item.children = []
                      res1.data.forEach(itm => {
                        let obj1 = {
                          value: String(itm.id),
                          label: itm.name,
                        }
                        item.children.push(obj1)
                      })

                    }
                    let value = 'o' + item.dictId
                    let obj = {
                      value: value,
                      label: item.dictName,
                      children: item.children
                    }
                    tempArr.push(obj)
                  })
                  this.jhyx_order_types = tempArr
                }
              })


            }
          }
        })
    },
    onChangeCurrentTab(status) {
      this.page.pageNo = 1
      this.page.pageSize = 10
      this.page.currentPage = 1
      let strTemp = 'all'
      let configTemp = [...this.columnCommon.config]
      this.columns.type = strTemp
      this.columns.config = Array.from(new Set(configTemp))
      this.fetchData('search')
    },
    fetchData(type) {
      this.loading = true
      this.axios.get('/orders/splitPageList?orderNo=' + this.$route.query.orderNo).then((res) => {
        if (res.code === 0) {
          this.page.list = res.data
          // this.page.totalNum = res.data.totalNum
          // if(this.currentTab === 1){params.status = 1}
          // this.getStatusCount(params)// 订单数量统计查询
          this.loading = false
          // this.getCount()
        } else {
          console.log('goodsPageList - 失败', type)
        }
      }).catch((err) => {
        console.log(err)
        this.loading = false
      })
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
      console.log(currentChange, 'currentChange')
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },

    // 订单数量统计查询
    getStatusCount(params) {
      // const params = {}
      this.$api.getStatusCount(params).then((res) => {
        this.statusCount = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 初始化，搜索需要的列表数据
    initSearchList() {
      const params = { pageNo: 1, pageSize: 1001 }
      // this.getPlatformDataList(params) // 平台
      // this.getShopDataList(params) // 店铺
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    }
  }
}
</script>
<style lang="scss">
.optionC {
  .el-cascader-panel {
    .el-scrollbar:first-child {
      .el-checkbox {
        display: none;
      }
    }
  }
}

el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader__suggestion-item.is-checked {
  color: #2d46ee;
  font-weight: 700;
}

.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #2d46ee;
  font-weight: 700;
}
</style>
<style scoped lang="scss">
.lForm {
  .el-input {
    width: 232px !important;
  }

  .el-select {
    width: 232px !important;
  }

  .el-range-editor {
    width: 232px !important;
  }
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.page {
  text-align: right;
  margin: 10px auto;
}

/deep/ .hide-content {
  display: none !important;
}

/deep/ .show-content {
  display: inline-block;
}

/deep/ .el-link {
  margin: 0 5px;
}

.search-form .el-form-item {
  width: 100%;
  // max-width: 295px;
  width: 250px;
  margin-right: 10px;
}

/deep/ .el-table th>.cell,
/deep/ .el-table td {
  text-align: unset;
}

.tabclass {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.yellowBtn,
.blueBtn,
.serviceDerive,
.promotionDerive {
  height: 36px;
  border-radius: 4px;
  margin-bottom: 10px;
}

.yellowBtn {
  //width: 160px;
  //height: 36px;
  background: #edb840;
  //border-radius: 4px;
}

.blueBtn {
  //width: 120px;
  //height: 36px;
  background: #4168e7;
  //border-radius: 4px;
}

.serviceDerive {
  //width: 160px !important;
  background: #67c23a !important;
}

.promotionDerive {
  //width: 160px !important;
  background: #e6a23c !important;
}

.serviceDeriveTwo {
  //width: 160px !important;
  background: #0f82c5 !important;
}

.promotionDeriveTwo {
  //width: 160px !important;
  background: #b705fd !important;
}

.tabBtn {
  //width: 100px;
  height: 36px;
  padding: 0 12px;
  border-radius: 4px;
  margin-bottom: 10px;
}

/deep/ .el-tabs {
  margin-top: 20px;

  .el-tabs__header {
    .el-tabs__nav-wrap {
      .el-tabs__nav-scroll {
        padding: 0;

        .el-tabs__nav {
          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__item {
            margin-right: 20px;
            width: 120px;
            height: 36px;
            padding: 0;
            text-align: center;
            line-height: 36px;
            font-size: 16px;
            color: #999999;
            border-radius: 4px;
            background: #ececec;
          }

          .el-tabs__item.is-active {
            color: #333333;
            background: #e3edff;
          }
        }
      }
    }
  }

  .el-tabs__nav-wrap::after {
    display: none;
  }
}

.shopTitle {
  margin-bottom: 20px;
}

// /deep/ .el-button {
//   border: none;
// }

.search-form {
  .el-form-item {
    max-width: 312px;

    /deep/ .el-form-item__label {
      width: 100px;
    }

    /deep/ .el-form-item__content {
      width: calc(100% - 100px);

      // .el-date-editor {
      //   //width: calc(100% - 82px);
      // }
    }
  }
}

.orderNotes {
  margin-top: 24px;
  padding-bottom: 25px;
  border-bottom: 1px solid #d9d9d9;

  .headerOrder {
    .orderRemak {
      margin-bottom: 12px;
      font-size: 18px;
    }
  }
}

/deep/ .el-textarea__inner {
  height: 132px;
}

.statistics {
  margin-top: 30px;
  display: flex;
  justify-content: right;
  align-items: center;

  .fourteen {
    font-size: 14px;
    padding-right: 20px;
  }

  .blue {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 0px;
    color: #4168e7;
  }
}

.present {
  display: flex;
  justify-content: right;
  height: 36px;
  margin-top: 30px;
  padding-bottom: 28px;
}

.tabsBtn {
  display: flex;
}

.dialogBtnright {
  display: flex;
  justify-content: space-between;
}

.dialogBtnright_right {
  display: flex;
  justify-content: right !important;
}

.setPay_payment_btn_quxiao {
  width: 120px;
  height: 36px;
  border: 1px solid #d9d9d9;
  background-color: #ffffff;
  color: rgba(153, 153, 153, 1);
  border-radius: 4px;
  line-height: 0;
}

.setPay_payment_btn_queren {
  width: 120px;
  height: 36px;
  background: #4168e7;
  opacity: 1;
  border-radius: 4px;
  line-height: 0;
  border: 0;
}

.setPay_payment {
  display: block;
  margin-bottom: 15px;
}

.dialog-btn {
  text-align: right;
}

/deep/ .el-table__row td .cell p {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}

/*
  /deep/.el-table__row td .cell span, /deep/.el-table__row td .cell div p{
    display: block;
    overflow : hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  */
/deep/ .el-scrollbar {
  height: 10px;
}

/deep/ .el-scrollbar__bar.is-horizontal {
  height: 9px;
}

::v-deep .el-form-item__label {
  padding: 0px 10px 0 0;
}
</style>